import script from "./ActivateCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivateCard.vue?vue&type=script&setup=true&lang=js"

import "./ActivateCard.vue?vue&type=style&index=0&id=5f8d86a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f8d86a0"]])

export default __exports__